var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLays(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1583.3 1346",
    style: {
      enableBackground: "new 0 0 1583.3 1346"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill:#FFFFFE;}\n\t.st19{fill:#EBC757;}\n\t.st20{fill:#C71D1F;}\n\t.st21{fill:#BEA05E;}\n\t.st22{fill:#FFFFFF;}\n\t.st23{font-family:'ArialMT';}\n\t.st24{font-size:46.2434px;}\n\t.st25{fill:#B81918;}\n\t.st26{font-size:28.4618px;}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 168.6864,
    cy: 952.3357,
    r: 103.986,
    fx: 164.1925,
    fy: 951.1587,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAF192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    style: {
      stopColor: "#FBEF7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    style: {
      stopColor: "#FBED60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#FBDE55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FACB48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#F9BB3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    style: {
      stopColor: "#F8B038"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#F7A934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A633"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 765.7,
    cy: 673,
    r: 673
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.8214,
    y1: 910.2567,
    x2: 157.9544,
    y2: 910.2567,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    style: {
      stopColor: "#FFF487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#E0C253"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    style: {
      stopColor: "#BD9526"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    style: {
      stopColor: "#B18516"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.6,1240.2c0,0-285.9-24.8-316.2-178.9l24.8-100.2h41.6C146.7,962.2,223.2,1151.3,396.6,1240.2L396.6,1240.2 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.1654,
    y1: 987.2378,
    x2: 250.2374,
    y2: 987.2378,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#B3881B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#B99128"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#C3A03E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#D2B65F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    style: {
      stopColor: "#E6D48B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    style: {
      stopColor: "#F3E9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#F0E5A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    style: {
      stopColor: "#D0B25A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#BC9530"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    style: {
      stopColor: "#B58B21"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1197.9,139.6c0,0,131.7,122.7,147.4,175.6c15.8,52.9,90-61.9,90-61.9S1343,142.9,1197.9,139.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.7218,
    y1: 938.4807,
    x2: 255.1628,
    y2: 969.1416,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8A1710"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#8A1710"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    style: {
      stopColor: "#A41913"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    style: {
      stopColor: "#BB1814"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    style: {
      stopColor: "#CD1714"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    style: {
      stopColor: "#DA1514"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    style: {
      stopColor: "#E11413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#E41313"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    style: {
      stopColor: "#DD1513"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    style: {
      stopColor: "#CA1714"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    style: {
      stopColor: "#AC1813"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85160E"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1340.8,318.5c10.1,1.1,19.1-1.1,24.8-10.1h5.6c31.5-13.5,49.5-38.3,59.6-69.8c21.4,18,32.6,41.6,45,65.3 c30.4,56.3,48.4,115.9,65.3,177.8c29.3,113.7,38.3,228.5,41.6,344.4c0,6.8,2.3,13.5-2.3,19.1c-34.9,36-76.5,61.9-122.7,78.8 c-55.1,20.3-113.7,28.1-172.2,29.3c-59.6,1.1-119.3,0-178.9-6.8c-25.9-2.3-56.3-9-78.8,14.6c-1.1,1.1-3.4,1.1-4.5,1.1 c-37.1,9-74.3,3.4-112.5-1.1c7.9-1.1,16.9-1.1,24.8-1.1c79.9-1.1,129.4-40.5,148.6-118.2c20.3-79.9,36-160.9,51.8-242 c2.3-13.5,10.1-28.1,2.3-42.8c1.1-3.4,1.1-6.8,2.3-9c7.9-5.6,5.6-13.5,4.5-21.4l16.9-70.9c2.3-11.3,6.8-22.5,7.9-34.9 c2.3-12.4,0-21.4-16.9-20.3c-27,1.1-52.9,1.1-79.9,0c-13.5-1.1-18,5.6-21.4,18c-11.3,55.1-23.6,111.4-36,166.6 c-9,39.4-19.1,76.5-41.6,111.4c-9,13.5-19.1,24.8-33.8,30.4c-16.9,6.8-24.8,3.4-30.4-14.6c-4.5-15.8-3.4-31.5,0-47.3 c12.4-58.5,25.9-117,38.3-175.6c4.5-22.5,10.1-43.9,14.6-66.4c3.4-20.3,1.1-22.5-16.9-22.5c-25.9,0-51.8,1.1-78.8,0 c-14.6-1.1-19.1,4.5-22.5,18c-15.8,74.3-32.6,149.7-49.5,224c-7.9,34.9-30.4,63-58.5,84.4c-16.9,13.5-28.1,7.9-31.5-13.5 c-1.1-10.1-1.1-20.3,1.1-30.4c10.1-49.5,20.3-99,30.4-147.4c7.9-37.1,15.8-75.4,23.6-112.5c4.5-21.4,4.5-21.4-16.9-21.4h-57.4 c-7.9,0-15.8,0-23.6,1.1c-10.1,1.1-5.6,14.6-13.5,19.1c-15.8-20.3-37.1-29.3-61.9-30.4c-32.6-1.1-61.9,7.9-90,24.8 c-92.3,57.4-155.3,210.5-128.3,316.2c6.8,27,18,51.8,41.6,67.5v1.1h1.1c2.3,1.1,4.5,3.4,6.8,4.5c3.4,5.6,7.9,10.1,13.5,12.4 c40.5,18,90,10.1,122.7-20.3c12.4-11.3,24.8-21.4,37.1-31.5c3.4,11.3,10.1,20.3,16.9,29.3c0,2.3,0,2.3,2.3,1.1l3.4,3.4v1.1h1.1 l3.4,3.4c-1.1,5.6,4.5,6.8,7.9,9c38.3,24.8,75.4,16.9,111.4-4.5c21.4-12.4,37.1-30.4,54-48.4c23.6,45,46.1,57.4,96.8,52.9 c30.4-2.3,55.1-16.9,78.8-34.9c-2.3,15.8-4.5,31.5-7.9,46.1c-6.8,30.4-23.6,45-55.1,43.9c-23.6,0-47.3-3.4-70.9-3.4 c-33.8-1.1-59.6,12.4-76.5,42.8c-12.4-4.5-20.3,0-23.6,12.4c-1.1,5.6-3.4,10.1-5.6,14.6c-4.5,11.3-15.8,12.4-22.5,10.1 c-7.9-2.3,0-11.3,2.3-15.8c5.6-13.5,11.3-25.9,15.8-39.4c2.3-6.8,5.6-14.6-5.6-16.9c1.1-7.9,0-11.3-10.1-9 c-73.2,18-147.4,14.6-220.6,5.6c-66.4-7.9-132.8-16.9-200.3-12.4c-10.1-1.1-12.4-5.6-10.1-14.6c38.3-175.6,75.4-352.3,113.7-527.8 c2.3-11.3,3.4-20.3-2.3-30.4c0-9-6.8-6.8-12.4-6.8h-126c-9,0-13.5,2.3-11.3,12.4c2.3,18,0,34.9-3.4,52.9 c-25.9,141.8-59.6,281.4-87.8,422c-11.3,55.1-23.6,110.3-36,166.6c-4.5,22.5-4.5,21.4,18,19.1c56.3-5.6,112.5-3.4,167.7-5.6 c4.5,7.9,12.4,10.1,21.4,10.1l37.1,3.4c-40.5,1.1-81,6.8-121.5,10.1c-21.4,1.1-41.6,7.9-59.6,19.1c-37.1,22.5-68.7,51.8-92.3,88.9 C49.9,999.4,29.7,919.5,15,836.2C2.7,767.5-3,697.8,1.5,628c5.6-102.4,24.8-202.6,75.4-293.7c10.1-18,28.1-25.9,45-34.9 c40.5-24.8,85.5-40.5,130.5-56.3c36-9,72-15.8,109.2-18c91.2-5.6,181.2,3.4,270.1,20.3c72,13.5,141.8,31.5,213.8,45 c68.7,14.6,137.3,31.5,207.1,39.4c55.1,6.8,109.2,10.1,164.3,11.3c-2.3,11.3-5.6,21.4-7.9,32.6c-3.4,1.1-4.5,3.4-3.4,6.8 c-1.1,2.3-2.3,4.5-4.5,6.8h-1.1v1.1c-1.1,1.1-2.3,2.3-2.3,3.4c5.6,12.4,16.9,14.6,28.1,12.4c28.1-4.5,54-14.6,68.7-40.5 C1305.9,343.3,1316,324.1,1340.8,318.5L1340.8,318.5z M1160.7,802.4l1.1,1.1c2.3,6.8,7.9,7.9,13.5,10.1c28.1,14.6,59.6,14.6,90,12.4 c46.1-3.4,90-14.6,124.9-47.3c38.3-36,51.8-90,30.4-129.4c-2.3-6.8-4.5-12.4-9-18c-22.5-33.8-52.9-59.6-83.3-85.5 c-12.4-10.1-25.9-21.4-31.5-37.1c14.6-46.1,43.9-58.5,83.3-36c45,24.8,81,9,93.4-41.6c0,0-3.4-1.1-4.5-2.3 c2.3-11.3-3.4-16.9-13.5-20.3c-67.5-20.3-133.9-22.5-196.9,14.6c-39.4,22.5-66.4,56.3-67.5,105.8c-1.1,49.5,27,81,61.9,110.3 c16.9,14.6,34.9,28.1,50.6,43.9c18,18,20.3,41.6,9,57.4c-11.3,15.8-38.3,22.5-59.6,12.4c-11.3-4.5-21.4-11.3-31.5-16.9 c-28.1-14.6-51.8-11.3-73.2,10.1c-28.1,27-27,33.8,5.6,55.1C1156.2,802.4,1158.5,803.5,1160.7,802.4L1160.7,802.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.9215,
    y1: 920.9567,
    x2: 263.3215,
    y2: 920.9567,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#A68904"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#D8BB70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    style: {
      stopColor: "#8F853B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEBD7B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.7,1119.8c0,0,51.8-132.8,302.7-166.6c251-33.8,601,18,601,18s468.2,84.4,577.3-106.9l-2.3-23.6 c0,0-93.4,167.7-548.1,96.8s-827.2-50.6-951,135.1L101.7,1119.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.5154,
    y1: 925.6,
    x2: 187.7464,
    y2: 925.6,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M721.8,875.6c-2.3,0-4.5,1.1-6.8,1.1c-5.6,13.5-11.3,25.9-16.9,39.4c-14.6,34.9-41.6,48.4-76.5,50.6 c-46.1,2.3-92.3,1.1-138.4-6.8c-50.6-7.9-101.3-13.5-151.9-19.1c-11.3-1.1-23.6-3.4-34.9,1.1c-56.3,3.4-112.5,0-167.7,5.6h-4.5 c-3.4,15.8-1.1,15.8,19.1,13.5c56.3-5.6,112.5-3.4,167.7-5.6c11.3-4.5,23.6-2.3,34.9-1.1c50.6,5.6,101.3,11.3,151.9,19.1 c46.1,6.8,92.3,9,138.4,6.8c34.9-1.1,63-15.8,76.5-50.6c6.8-15.8,12.4-30.4,19.1-46.1C733.1,876.7,730.8,873.3,721.8,875.6 L721.8,875.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.3035,
    y1: 957.2004,
    x2: 158.3185,
    y2: 957.2004,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M344.8,473.8c-25.9,120.4-51.8,242-76.5,362.4c-3.4,16.9-2.3,20.3,13.5,19.1c0-1.1,1.1-3.4,1.1-4.5 c25.9-120.4,50.6-242,76.5-362.4c13.5-64.1,25.9-128.3,42.8-192.4c0-7.9-6.8-6.8-12.4-6.8h-4.5C369.6,350,357.2,411.9,344.8,473.8 L344.8,473.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.2074,
    y1: 975.2702,
    x2: 238.8674,
    y2: 975.2702,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1302.5,332h-11.3c-10.1,27-41.6,56.3-73.2,59.6h-1.1l-3.4,6.8c1.1,1.1,1.1,2.3-1.1,1.1 c-1.1,1.1-1.1,2.3-2.3,3.4c39.4,14.6,86.7-25.9,96.8-60.8C1308.2,337.6,1307,332,1302.5,332z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.4834,
    y1: 944.8337,
    x2: 250.6204,
    y2: 944.8337,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1427.4,643.7c-12.4-18-27-34.9-42.8-49.5c10.1,11.3,20.3,22.5,28.1,34.9c3.4,5.6,6.8,11.3,9,18 c6.8,28.1,2.3,54-10.1,78.8c-29.3,57.4-79.9,81-141.8,86.7c-36,3.4-73.2,2.3-108-10.1l-1.1-1.1c-1.1-3.4-3.4-3.4-5.6-2.3l-10.1-6.8 c2.3,6.8,11.3,12.4,24.8,21.4c2.3-1.1,4.5,0,5.6,2.3l1.1,1.1c34.9,12.4,70.9,13.5,108,10.1c60.8-5.6,111.4-29.3,141.8-86.7 c12.4-24.8,16.9-50.6,10.1-78.8C1434.2,655,1431.9,649.4,1427.4,643.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.9664,
    y1: 949.9567,
    x2: 239.1284,
    y2: 949.9567,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1254.1,634.7c-4.5-3.4-9-7.9-13.5-11.3c7.9,9,18,18,28.1,25.9c13.5,11.3,28.1,22.5,41.6,34.9 c-1.1-2.3-3.4-3.4-4.5-5.6C1290.1,662.9,1272.1,649.4,1254.1,634.7L1254.1,634.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.5414,
    y1: 965.5067,
    x2: 254.6917,
    y2: 965.5067,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1471.3,419.8v6.8c-6.8,0-9,5.6-10.1,10.1c-19.1,45-57.4,40.5-86.7,21.4c-7.9-4.5-15.8-9-24.8-10.1 c-19.1-2.3-34.9,3.4-47.3,18c-9,12.4-15.8,25.9-3.4,40.5c4.5,13.5,13.5,22.5,23.6,31.5c-4.5-4.5-7.9-10.1-10.1-16.9 c-11.3-14.6-5.6-28.1,3.4-40.5c11.3-15.8,28.1-20.3,47.3-18c9,1.1,16.9,5.6,24.8,10.1c28.1,18,66.4,23.6,86.7-21.4 c2.3-4.5,3.4-10.1,10.1-10.1C1487.1,428.8,1482.6,423.2,1471.3,419.8L1471.3,419.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.7054,
    y1: 955.5096,
    x2: 177.6304,
    y2: 955.5096,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M610.4,465.9c-2.3-9-10.1-9-16.9-9c-22.5-1.1-38.3,12.4-49.5,29.3c-38.3,56.3-56.3,119.3-58.5,186.8 c0,12.4-4.5,28.1,9,39.4c3.4,6.8,7.9,11.3,13.5,13.5c-12.4-10.1-7.9-25.9-7.9-38.3c2.3-67.5,20.3-130.5,58.5-186.8 c11.3-16.9,27-30.4,49.5-29.3c3.4,0,7.9,0,11.3,2.3C616,470.4,613.8,468.2,610.4,465.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.9614,
    y1: 937.7874,
    x2: 175.6614,
    y2: 937.7874,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M426.9,812.6c1.1,0,1.1,1.1,1.1,1.1c2.3,1.1,4.5,3.4,6.8,4.5c14.6,2.3,28.1,9,42.8,10.1 c47.3,2.3,83.3-18,112.5-52.9l5.6-5.6c0-1.1-1.1-2.3-1.1-3.4c-2.3-18-9-15.8-19.1-4.5c-29.3,33.8-65.3,55.1-112.5,52.9 c-14.6-1.1-28.1-7.9-42.8-10.1c-2.3-1.1-4.5-3.4-6.8-4.5h-1.1V799c-2.3-1.1-3.4-2.3-4.5-3.4C413.4,801.3,420.2,806.9,426.9,812.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.9565,
    y1: 938.2072,
    x2: 193.5244,
    y2: 938.2072,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M792.7,768.7c1.1-1.1,2.3-3.4,4.5-5.6c-1.1-1.1-2.3-3.4-2.3-5.6c1.1-5.6-1.1-10.1-4.5-12.4 c-4.5-1.1-7.9,4.5-10.1,7.9c-45,50.6-93.4,75.4-156.4,48.4c1.1,2.3,2.3,3.4,4.5,5.6c2.3-1.1,2.3,0,2.3,1.1l3.4,3.4l3.4,3.4 C698.2,844.1,747.7,819.3,792.7,768.7L792.7,768.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.9834,
    y1: 946.4274,
    x2: 227.9344,
    y2: 946.4274,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1151.7,570.6c1.1-3.4,1.1-6.8,2.3-9c2.3-7.9,2.3-13.5,4.5-21.4l16.9-70.9c2.3-11.3,6.8-22.5,7.9-34.9 c1.1-11.3,0-19.1-13.5-20.3v5.6c-2.3,11.3-5.6,22.5-7.9,34.9l-16.9,70.9c-2.3,6.8-4.5,12.4-6.8,21.4c-1.1,3.4-1.1,6.8-2.3,10.1 c-3.4,15.8-5.6,23.6-7.9,34.9c-16.9,78.8-31.5,158.7-51.8,237.5c-16.9,68.7-56.3,114.8-139.6,117c-41.6,1.1-84.4-1.1-126-1.1 c-15.8,0-31.5,4.5-47.3,9c-1.1,2.3-2.3,3.4-2.3,5.6c-2.3,3.4-5.6,6.8-1.1,11.3c3.4,3.4,6.8,1.1,11.3,0c18-5.6,34.9-12.4,54-11.3 c41.6,0,84.4,2.3,126,1.1c83.3-2.3,122.7-48.4,139.6-117c20.3-78.8,34.9-157.6,51.8-237.5C1145,594.2,1148.3,581.8,1151.7,570.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.2714,
    y1: 957.1067,
    x2: 191.7804,
    y2: 957.1067,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M761.2,422c-7.9,37.1-15.8,75.4-23.6,112.5c-10.1,49.5-20.3,99-30.4,147.4c-2.3,10.1-3.4,20.3-1.1,30.4 c2.3,13.5,7.9,20.3,15.8,20.3c-1.1-2.3-1.1-4.5-1.1-6.8c-1.1-10.1-1.1-20.3,1.1-30.4c10.1-49.5,20.3-99,30.4-147.4 c7.9-37.1,15.8-75.4,23.6-112.5c4.5-19.1,4.5-21.4-12.4-21.4C762.3,416.4,761.2,418.7,761.2,422L761.2,422z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.9584,
    y1: 936.8705,
    x2: 208.8714,
    y2: 936.8705,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M824.2,797.9c19.1,23.6,41.6,30.4,81,27c22.5-2.3,42.8-10.1,60.8-21.4c1.1-9,2.3-18,4.5-27 c-23.6,18-48.4,32.6-78.8,34.9C861.4,813.7,841.1,810.3,824.2,797.9L824.2,797.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.2454,
    y1: 957.1567,
    x2: 209.6654,
    y2: 957.1567,
    gradientTransform: "matrix(11.2542 0 0 -11.2542 -1380.7152 11344.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#DBB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#FFFAD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#E9D497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    style: {
      stopColor: "#CAA750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#B88E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#B18516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#C8B166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#CEBD7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFAD2"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M962.6,423.2c-4.5,22.5-10.1,43.9-14.6,66.4c-12.4,58.5-25.9,117-38.3,175.6c-3.4,15.8-5.6,31.5,0,47.3 c3.4,11.3,7.9,16.9,15.8,18c0-1.1-1.1-2.3-1.1-3.4c-4.5-15.8-3.4-31.5,0-47.3c12.4-58.5,25.9-117,38.3-175.6 c4.5-22.5,10.1-43.9,14.6-66.4c3.4-18,1.1-21.4-13.5-22.5C963.8,416.4,963.8,419.8,962.6,423.2L962.6,423.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1138.2,557.1c-3.4,12.4-6.8,23.6-10.1,34.9c-16.9,78.8-31.5,158.7-51.8,237.5 c-16.9,68.7-56.3,114.8-139.6,117c-41.6,1.1-84.4-1.1-126-1.1c-19.1,0-36,6.8-54,11.3c-4.5,1.1-7.9,3.4-11.3,0 c-4.5-4.5,0-6.8,1.1-11.3c5.6-12.4,11.3-25.9,14.6-39.4c15.8-30.4,42.8-42.8,76.5-42.8c23.6,0,47.3,3.4,70.9,3.4 c31.5,0,48.4-13.5,55.1-43.9c3.4-14.6,4.5-30.4,7.9-46.1c-23.6,18-48.4,32.6-78.8,34.9c-50.6,4.5-73.2-7.9-96.8-52.9 c1.1-5.6-1.1-10.1-4.5-12.4c-4.5-1.1-7.9,4.5-10.1,7.9c-45,50.6-94.5,75.4-158.7,48.4l-3.4-3.4l-3.4-3.4c0-1.1,0-2.3-2.3-1.1 c-6.8-9-13.5-18-16.9-29.3c-2.3-18-9-15.8-19.1-4.5c-29.3,33.8-65.3,55.1-112.5,52.9c-14.6-1.1-28.1-7.9-42.8-10.1 c-2.3-1.1-4.5-3.4-6.8-4.5v-1.1h-1.1c-23.6-16.9-34.9-40.5-41.6-67.5c-27-105.8,34.9-258.8,128.3-316.2c27-16.9,57.4-25.9,90-24.8 c24.8,1.1,46.1,10.1,61.9,30.4c7.9-4.5,3.4-18,13.5-19.1c7.9-1.1,15.8-1.1,23.6-1.1h57.4c20.3,0,21.4,0,16.9,21.4 c-7.9,37.1-15.8,75.4-23.6,112.5c-10.1,49.5-20.3,99-30.4,147.4c-2.3,10.1-3.4,20.3-1.1,30.4c3.4,21.4,14.6,27,31.5,13.5 c28.1-21.4,49.5-49.5,58.5-84.4c18-74.3,33.8-148.6,49.5-224c3.4-13.5,7.9-19.1,22.5-18c25.9,1.1,51.8,0,78.8,0 c18,0,21.4,2.3,16.9,22.5c-4.5,22.5-10.1,43.9-14.6,66.4c-12.4,58.5-25.9,117-38.3,175.6c-3.4,15.8-5.6,31.5,0,47.3 c5.6,18,13.5,21.4,30.4,14.6c14.6-5.6,24.8-18,33.8-30.4c22.5-33.8,32.6-72,41.6-111.4c12.4-55.1,24.8-111.4,36-166.6 c2.3-12.4,6.8-18,21.4-18c27,1.1,52.9,1.1,79.9,0c16.9-1.1,19.1,7.9,16.9,20.3c-2.3,11.3-5.6,22.5-7.9,34.9l-16.9,70.9 c-2.3,7.9-3.4,13.5-4.5,21.4C1139.3,551.5,1138.2,553.7,1138.2,557.1L1138.2,557.1z M493.3,713.5c9,14.6,20.3,19.1,37.1,12.4 c28.1-10.1,40.5-33.8,51.8-57.4c24.8-50.6,34.9-104.7,43.9-159.8c2.3-15.8,0-31.5-16.9-41.6c-2.3-9-10.1-9-16.9-9 c-22.5-1.1-38.3,12.4-49.5,29.3c-38.3,56.3-56.3,119.3-58.5,186.8C484.3,686.5,481,702.3,493.3,713.5L493.3,713.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M720.7,872.2c-6.8,15.8-12.4,30.4-19.1,46.1c-14.6,34.9-41.6,48.4-76.5,50.6c-46.1,2.3-92.3,1.1-138.4-6.8 c-50.6-7.9-101.3-13.5-151.9-19.1c-11.3-1.1-23.6-3.4-34.9,1.1c-56.3,3.4-112.5,0-167.7,5.6c-22.5,2.3-22.5,2.3-18-19.1 c11.3-55.1,24.8-110.3,36-166.6c29.3-140.7,61.9-281.4,87.8-422c3.4-18,5.6-34.9,3.4-52.9c-1.1-10.1,2.3-12.4,11.3-12.4h126 c4.5,0,11.3-2.3,12.4,6.8c-16.9,63-28.1,128.3-42.8,192.4c-25.9,120.4-51.8,242-76.5,362.4c-4.5,19.1-2.3,20.3,19.1,19.1 c67.5-4.5,133.9,5.6,200.3,12.4c74.3,7.9,147.4,12.4,220.6-5.6C720.7,859.8,722.9,863.2,720.7,872.2L720.7,872.2z M1299.1,507.6 c5.6,16.9,19.1,27,31.5,37.1c30.4,25.9,60.8,51.8,83.3,85.5c3.4,5.6,6.8,11.3,9,18c6.8,28.1,2.3,54-10.1,78.8 c-29.3,57.4-79.9,81-141.8,86.7c-36,3.4-73.2,2.3-108-10.1l-1.1-1.1c-1.1-3.4-3.4-3.4-5.6-2.3c-32.6-20.3-33.8-27-5.6-55.1 c21.4-21.4,45-24.8,73.2-10.1c10.1,5.6,20.3,12.4,31.5,16.9c21.4,9,48.4,3.4,59.6-12.4c12.4-15.8,9-39.4-9-57.4 c-15.8-15.8-33.8-29.3-50.6-43.9c-34.9-29.3-63-60.8-61.9-110.3s27-82.2,67.5-105.8c63-36,129.4-33.8,196.9-14.6 c11.3,3.4,15.8,9,13.5,20.3c-6.8,0-9,5.6-10.1,10.1c-19.1,45-57.4,40.5-86.7,21.4c-7.9-4.5-15.8-9-24.8-10.1 c-19.1-2.3-34.9,3.4-47.3,18C1293.5,479.4,1287.9,492.9,1299.1,507.6L1299.1,507.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M289.6,856.4c-21.4,1.1-22.5,0-19.1-19.1c25.9-120.4,50.6-242,76.5-362.4c13.5-64.1,25.9-128.3,42.8-192.4 c5.6,10.1,5.6,19.1,2.3,30.4c-38.3,175.6-75.4,352.3-113.7,527.8C278.4,850.8,279.5,855.3,289.6,856.4L289.6,856.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1218.1,341c9-4.5,2.3-20.3,13.5-20.3c20.3-1.1,40.5,0,59.6,0c4.5,0,5.6,5.6,4.5,10.1 c-11.3,33.8-57.4,74.3-96.8,60.8c1.1-1.1,2.3-2.3,2.3-3.4c2.3,1.1,1.1,0,1.1-1.1l3.4-6.8c3.4-1.1,4.5-3.4,3.4-6.8 C1213.6,362.4,1215.9,351.1,1218.1,341z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1210.2,372.5c0,3.4,0,5.6-3.4,6.8C1206.9,377,1208,374.8,1210.2,372.5z M1203.5,386c1.1,1.1,1.1,2.3-1.1,1.1 V386H1203.5z M611.5,794.5c2.3-1.1,2.3,0,2.3,1.1C611.5,796.8,611.5,796.8,611.5,794.5z M1156.2,799c2.3-1.1,4.5,0,5.6,2.3 C1158.5,803.5,1156.2,802.4,1156.2,799z M413.4,799h1.1v1.1h-1.1V799z M617.1,800.2H616H617.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M610.4,467c15.8,10.1,19.1,25.9,16.9,41.6c-7.9,55.1-19.1,109.2-43.9,159.8c-11.3,23.6-24.8,47.3-51.8,57.4 c-16.9,5.6-28.1,2.3-37.1-12.4c0-10.1-1.1-20.3-1.1-30.4c2.3-59.6,20.3-114.8,47.3-167.7C555.2,487.3,576.6,468.2,610.4,467 L610.4,467z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M626.1,808.1c2.3-1.1,2.3,0,2.3,1.1C626.1,810.3,626.1,809.2,626.1,808.1z M426.9,812.6h1.1v1.1h-1.1V812.6z  M631.8,812.6l-1.1,1.1L631.8,812.6z M611.5,793.4c2.3-1.1,2.3,0,2.3,1.1C611.5,796.8,611.5,795.7,611.5,793.4z M413.4,797.9h1.1 v1.1l-1.1,1.1V797.9z M617.1,799H616H617.1z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1121.272 901.0141)",
    className: "st22 st23 st24"
  }, "BRAND")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1405.8657 1040.9282)",
    className: "st25 st23 st26"
  }, "TM")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLays);
export default __webpack_public_path__ + "static/media/lays.9fc4261693a50c8f5c6b57a614126ecc.svg";
export { ForwardRef as ReactComponent };